import { trpc } from "../../main/components/trpc.ts";

const formatRate = (rate: number) =>
  `${(rate * 100).toLocaleString("fr-FR", {
    maximumFractionDigits: 1,
  })} %`;

export default function WeeklyFillStats() {
  const weeklyFillStatsQuery = trpc.stats.getWeeklyFillStats.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
  });

  const weeklyStats = weeklyFillStatsQuery.data?.weeklyStats;

  return (
    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ marginBottom: "0.5rem", fontWeight: "bold", fontSize: "1.25rem" }}>
        Dispersion du remplissage hebdomadaire
      </h2>
      <p style={{ marginBottom: "1rem" }}>
        Pour chaque semaine complète (semaine ISO du lundi au dimanche), le
        remplissage réalisé est le rapport entre les minutes de rdvs honorés et
        les minutes disponibles. Les semaines sans horaires configurés, la
        semaine en cours et l'année en cours sont exclues. Les percentiles sont
        calculés par interpolation linéaire sur la distribution des semaines.
      </p>
      {weeklyFillStatsQuery.isLoading ? (
        <p>Calcul des statistiques...</p>
      ) : null}
      {weeklyFillStatsQuery.error ? (
        <p role="alert" style={{ color: "#b91c1c", marginTop: "0.5rem" }}>
          Impossible de calculer les statistiques :{" "}
          {weeklyFillStatsQuery.error.message}
        </p>
      ) : null}
      {weeklyStats && weeklyStats.length > 0 ? (
        <div style={{ marginTop: "1rem", overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", minWidth: "800px", width: "100%" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "0.5rem" }}>Année</th>
                <th style={{ textAlign: "right", padding: "0.5rem" }}>Semaines considérées</th>
                <th style={{ textAlign: "right", padding: "0.5rem" }}>Moyenne</th>
                <th style={{ textAlign: "right", padding: "0.5rem" }}>Médiane</th>
                <th style={{ textAlign: "right", padding: "0.5rem" }}>25e percentile</th>
                <th style={{ textAlign: "right", padding: "0.5rem" }}>10e percentile</th>
                <th style={{ textAlign: "right", padding: "0.5rem" }}>Semaines à moins de 70 %</th>
              </tr>
            </thead>
            <tbody>
              {weeklyStats.map((yearStats) => (
                <tr key={yearStats.year}>
                  <td style={{ padding: "0.5rem" }}>{yearStats.year}</td>
                  <td style={{ textAlign: "right", padding: "0.5rem" }}>
                    {yearStats.weekCount}
                  </td>
                  <td style={{ textAlign: "right", padding: "0.5rem" }}>
                    {formatRate(yearStats.meanFillRate)}
                  </td>
                  <td style={{ textAlign: "right", padding: "0.5rem" }}>
                    {formatRate(yearStats.medianFillRate)}
                  </td>
                  <td style={{ textAlign: "right", padding: "0.5rem" }}>
                    {formatRate(yearStats.p25FillRate)}
                  </td>
                  <td style={{ textAlign: "right", padding: "0.5rem" }}>
                    {formatRate(yearStats.p10FillRate)}
                  </td>
                  <td style={{ textAlign: "right", padding: "0.5rem" }}>
                    {yearStats.weeksBelow70Percent}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </section>
  );
}
